import {useState} from 'react'
import {Modal, ModalBody, ModalFooter, ModalHeader} from 'react-bootstrap'
import doRequest from "../../requests/requests"
import './User.css'
import Button from 'react-bootstrap/Button'

function Register({showRegister, toggle}) {
    let uri = "https://sshm4damsapi.fly.dev"
    const [username, setUsername] = useState('')
    const [password, setPassword] = useState('')
    const [role, setRole] = useState('user')
    const register = async () => {
        try {
            const result = await doRequest({
                contentType: 'application/json',
                uri: uri + "/register",
                method: 'POST',
                body: {username, password, role}
            })
            if (result.ok) {
                alert('Registered successfully!')
                closeRegister()
            } else {
                alert('Register error')
                console.error(await result.json())
            }
        } catch (err) {
            alert('Register error')
            console.error(err)
        }
    }
    const userHandleChange = (event) => {
        setUsername(event.target.value)
    }
    const passwordHandleChange = (event) => {
        setPassword(event.target.value)
    }
    const closeRegister = () => {
        toggle(false)
    }
    return (
        <Modal show={showRegister} onHide={closeRegister}>
            <ModalHeader closeButton toggle={closeRegister}>
                Register
            </ModalHeader>
            <ModalBody className='register form'>
                <label>Username: </label>
                <input type="text" id="username" name="username" placeholder="Enter your user name" value={username}
                       onChange={userHandleChange} required/>
                <label>Password: </label>
                <input type="password" id="password" name="password" placeholder="Password" value={password}
                       onChange={passwordHandleChange} required/>
                <select onChange={(event) => {
                    setRole(event.value);
                }}>
                    <option value='user'>User</option>
                    {/* <option value='admin'>Admin</option> */}
                </select>
                <Button variant="primary" onClick={register}>Register</Button>

            </ModalBody>
            <ModalFooter>
                <Button variant="primary" onClick={closeRegister}>
                    Close
                </Button>
            </ModalFooter>
        </Modal>

    )
}

export default Register
